import _ from 'lodash';

export default function getBulkItemsSellerId(selectedItems) {
	if (
		_.every(selectedItems, item => {
			return item.sellerId == selectedItems[0].sellerId;
		})
	) {
		return selectedItems[0].sellerId;
	}
	return null;
}



// WEBPACK FOOTER //
// ./src/core/utils/getBulkItemsSellerId.js